import React from "react";
import BaseComponent from "meta/features/base-component";
import { Container } from "meta/ui2/layout";
import PageView from "./PageView";

import cn from "classnames";
import { withHooks } from "../hooks/withHooks";
import { useWebEvents } from "../webevents/useWebEvents";
import { defaultDockedTabWidth } from "../utils/constants";
import { getRootApi } from "meta/utils/getRootApi";

class MainContent extends BaseComponent {
  constructor(props) {
    super(props);

    this._bind("handleOnLoad");
  }

  handleOnLoad(key, url) {
    const { contentLoad } = this.props;

    getRootApi().FrontendEvents.contentLoad();
    contentLoad(key, url);
  }

  render() {
    const {
      onWebEvent,
      onModalWebEvent,
      onIframeRef,
      activeTabKey,
      activeDockedTabKey,
      tabs,
      userPreferences,
      rightPanelExpanded,
    } = this.props;

    const getPageViewWidthCore = () => {
      if (!userPreferences || !userPreferences.TabsDockedWidth || !tabs[activeDockedTabKey])
        return defaultDockedTabWidth;

      const activeDockedTabMenuId = tabs[activeDockedTabKey].menuId;
      return userPreferences.TabsDockedWidth[activeDockedTabMenuId]
        ? userPreferences.TabsDockedWidth[activeDockedTabMenuId]
        : defaultDockedTabWidth;
    };

    const getPageViewWidth = (key, tab) => {
      if (key === activeDockedTabKey) {
        return 100 - getPageViewWidthCore();
      } else if (activeDockedTabKey) {
        return getPageViewWidthCore();
      }
    };

    return (
      <Container fit className="_mainContent">
        {Object.entries(tabs).map(([key, tab]) => {
          const dockedActive = activeDockedTabKey === key;

          return (
            <PageView
              key={key}
              id={key}
              url={tab.url}
              visId={tab.VisID}
              className={cn({ docked: dockedActive })}
              onRef={(iframe) => onIframeRef(key, iframe)}
              frameSession={tab.frameSession}
              visible={key === activeTabKey || dockedActive}
              active={key === activeTabKey}
              dockedActive={dockedActive}
              onLoad={this.handleOnLoad}
              onWebEvent={(event) => onWebEvent(event)}
              onModalWebEvent={(event) => onModalWebEvent(event)}
              progress={tab.progress}
              refreshToken={tab.refreshToken}
              style={{
                maxWidth: rightPanelExpanded
                  ? tab.width || undefined
                  : undefined,
                minWidth: rightPanelExpanded
                  ? tab.width || undefined
                  : undefined,
                flexShrink: getPageViewWidth(key, tab),
                width:
                  !dockedActive || rightPanelExpanded ? "100%" : "fit-content",
              }}
              rightPanelExpanded={rightPanelExpanded}
            />
          );
        })}
      </Container>
    );
  }
}

export default withHooks(MainContent, useWebEvents);
